{
  "schemaVersion": "cogo.document-template.v1",
  "templateId": "golden-report-workspace",
  "templateVersion": "1.0.0",
  "documentType": "report-workspace",
  "locale": "ko-KR",
  "staticContent": {
    "eyebrow": "DOCUMENT ONTOLOGY CALIBRATION",
    "title": "템플릿 기반 문서 생성 온톨리지",
    "subtitle": "규칙 전용 입력과 LLM 보조 의미 입력의 첫 실증",
    "decisionLabel": "METHOD PROOF · SAME TEMPLATE · SAME COMPILER",
    "evaluationNote": "자동 검증은 구조와 재현성만 판정합니다. 내용의 유용성과 승격은 실제 산출물을 검토한 사람이 결정합니다.",
    "footer": "COOGO · DOCUMENT ONTOLOGY · GOLDEN TEMPLATE V1"
  },
  "layout": {
    "preset": "standard_business_brief",
    "firstPagePattern": "memo_masthead",
    "pageSize": "letter",
    "marginInches": {
      "top": 0.68,
      "right": 0.72,
      "bottom": 0.62,
      "left": 0.72
    },
    "slotOrder": ["executive-summary", "pricing-table"]
  },
  "slots": [
    {
      "id": "executive-summary",
      "kind": "rich-text",
      "required": true,
      "bindingPath": "/executiveSummary",
      "heading": "핵심 판단"
    },
    {
      "id": "pricing-table",
      "kind": "table",
      "required": true,
      "bindingPath": "/pricingTable",
      "heading": "역할·권한 계약",
      "columns": [
        {
          "key": "label",
          "label": "구성 요소",
          "widthRatio": 0.22
        },
        {
          "key": "value",
          "label": "역할과 결과",
          "widthRatio": 0.53
        },
        {
          "key": "evidenceRef",
          "label": "근거",
          "widthRatio": 0.25
        }
      ]
    }
  ],
  "assets": [
    {
      "role": "logo",
      "path": "assets/coogo-logo.svg"
    }
  ],
  "renderTargets": ["docx", "pdf"]
}
